// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__RZJw-","Menu":"SiderContentC_Menu__fjNen"};